import { ComplaintStatus } from "@modules/plaintes/plaintes.model.ts";
import React from "react";

interface StatusBodyProps {
  status: ComplaintStatus | string;
}

const StatusBody: React.FC<StatusBodyProps> = ({ status }) => {
  return (
    <>
      {status === ComplaintStatus.ARCHIVED && (
        <span className="bg-[#e9eee7] px-2 py-0.5 rounded-2xl text-xs font-medium text-[#1b1b0a] flex items-center whitespace-nowrap justify-center">
          <i
            className="pi pi-circle-fill text-[#616161] mr-2"
            style={{ fontSize: 6 }}
          />{" "}
          Archivé
        </span>
      )}
      {status === ComplaintStatus.IN_PROGRESS && (
        <span className="bg-[#fffc33] px-2 py-0.5 rounded-2xl text-xs font-medium text-[#1b1b0a] flex items-center whitespace-nowrap justify-center">
          <i
            className="pi pi-circle-fill text-[#FFC107] mr-2"
            style={{ fontSize: 6 }}
          />{" "}
          En cours
        </span>
      )}
      {status === ComplaintStatus.ESCALATED && (
        <span className="bg-[#d8d777] px-2 py-0.5 rounded-2xl text-xs font-medium text-[#1b1b0a] flex items-center whitespace-nowrap justify-center">
          <i
            className="pi pi-circle-fill text-[#363615] mr-2"
            style={{ fontSize: 6 }}
          />{" "}
          Escaladé
        </span>
      )}
      {status === ComplaintStatus.PENDING && (
        <span className="bg-[#fcad12] px-2 py-0.5 rounded-2xl text-xs font-medium text-[#1b1b0a] flex items-center whitespace-nowrap justify-center">
          <i
            className="pi pi-circle-fill text-[#FF9800] mr-2"
            style={{ fontSize: 6 }}
          />{" "}
          En attente
        </span>
      )}
      {status === ComplaintStatus.RESOLVED_POSITIVE && (
        <span className="bg-[#50f90e] px-2 py-0.5 rounded-2xl text-xs font-medium text-[#1b1b0a] flex items-center whitespace-nowrap justify-center">
          <i
            className="pi pi-circle-fill text-[#4CAF50] mr-2"
            style={{ fontSize: 6 }}
          />{" "}
          Résolu positif
        </span>
      )}
      {status === ComplaintStatus.RESOLVED_NEGATIVE && (
        <span className="bg-[#50f90e] px-2 py-0.5 rounded-2xl text-xs font-medium text-[#1b1b0a] flex items-center whitespace-nowrap justify-center">
          <i
            className="pi pi-circle-fill text-[#f90e0e] mr-2"
            style={{ fontSize: 6 }}
          />{" "}
          Résolu négatif
        </span>
      )}
      {status === ComplaintStatus.SAVED && (
        <span className="bg-[#0e7cf9] px-2 py-0.5 rounded-2xl text-xs font-medium text-[#1b1b0a] flex items-center whitespace-nowrap justify-center">
          <i
            className="pi pi-circle-fill text-[#0e39f9] mr-2"
            style={{ fontSize: 6 }}
          />{" "}
          Enregistrée
        </span>
      )}
      {status === ComplaintStatus.IN_PROGRESS_VALIDATION && (
        <span className="bg-[#f787cc] px-2 py-0.5 rounded-2xl text-xs font-medium text-[#1b1b0a] flex items-center whitespace-nowrap justify-center">
          <i
            className="pi pi-circle-fill text-[#f90eda] mr-2"
            style={{ fontSize: 6 }}
          />{" "}
          En cours de validation
        </span>
      )}
      {status === ComplaintStatus.CURRENTLY_PROCESSED && (
        <span className="bg-[#98d2f8] px-2 py-0.5 rounded-2xl text-xs font-medium text-[#1b1b0a] flex items-center whitespace-nowrap justify-center">
          <i
            className="pi pi-circle-fill text-[#f9d60e] mr-2"
            style={{ fontSize: 6 }}
          />{" "}
          En cours de traitement
        </span>
      )}
      {status === ComplaintStatus.AWAITING_RESPONSE && (
        <span className="bg-[#ca98f8] px-2 py-0.5 rounded-2xl text-xs font-medium text-[#1b1b0a] flex items-center whitespace-nowrap justify-center">
          <i
            className="pi pi-circle-fill text-[#870ef9] mr-2"
            style={{ fontSize: 6 }}
          />{" "}
          En attente de réponse
        </span>
      )}
      {status === ComplaintStatus.RESOLVED && (
        <span className="bg-[#98f8ad] px-2 py-0.5 rounded-2xl text-xs font-medium text-[#1b1b0a] flex items-center whitespace-nowrap justify-center">
          <i
            className="pi pi-circle-fill text-[#9ff90e] mr-2"
            style={{ fontSize: 6 }}
          />{" "}
          Résolu 
        </span>
      )}
    </>
  );
};
export default StatusBody;
